<template lang="pug">
  div
    v-date-picker(data-v-step='TourOrderCalendarView-2' v-model="dates" :range="range" :multiple="multiple" no-title :picker-date.sync="showMonth" :events="events" event-color="info400")
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: "CalendarPicker",
  props: ['parentDates', 'company', 'dateSelectionMode'],
  data: () => ({
    showMonth: null,
    events: []
  }),
  computed: {
    ...mapGetters({
      filters: 'orders/getFilters'
    }),
    range () {
      if (this.dateSelectionMode === 'range') {
        return true
      }
      return false
    },
    multiple () {
      if (this.dateSelectionMode === 'multiple') {
        return true
      }
      return false
    },
    dates: {
      get () {
        return this.parentDates
      },
      set (newValue) {
        this.$emit('update:parentDates', newValue)
      }
    },
  },
  watch: {
    showMonth: {
      immediate: true,
      handler (val) {
        if (val) {
          this.fetchEvents(val)
        }
      }
    },
    'filters.date' () {
      if (this.showMonth) {
        this.fetchEvents(this.showMonth)
      }
    }
  },
  mounted () {
  },
  methods: {
    fetchEvents (val) {
      let year = val.substr(0, 4)
      let month = val.substr(5, 2)
      let type = 'processed_at'
      if (this.filters.date === 'scheduled') {
        type = 'asking_delivery_date'
      }
      this.$axios.get(`/leads/dates_exist?company_id=${this.company.id}&year=${year}&month=${month}&status=processed&form_type_exclude=book_income&form__company=${this.company.id}&date_type=${type}`)
        .then(resp => {
          this.events = resp.data
        })
    }
  }
}
</script>

<style scoped>
::v-deep .v-date-picker-title__year {
  display: none;
}
::v-deep .v-date-picker-title__date {
  display: none;
}
::v-deep .v-picker__title {
  padding: 0;
}
::v-deep .v-picker__body{
  width: 100% !important;
}
::v-deep .v-date-picker-header {
  height: 50px;
}

::v-deep .v-date-picker-header > button {
  position: absolute !important;
  width: 24px;
  border-radius: 5px;
  color: black !important; /*change month and arrow color*/
}

::v-deep .v-date-picker-header > button[aria-label="Previous month"],
::v-deep .v-date-picker-header > button[aria-label="Previous year"] {
  right: 53px;
  font-size: 20px;
}

::v-deep .v-date-picker-header > button[aria-label="Next month"],
::v-deep .v-date-picker-header > button[aria-label="Next year"] {
  right: 24px;
}

::v-deep .v-date-picker-header > div {
  position: absolute !important;
  font-size: 14px;
  font-weight: 700;
}

::v-deep .v-date-picker-header .v-date-picker-header__value button::after {
  font-family: "Material Design Icons";
  content: "\F0140";
  margin-left: 12px;
}
::v-deep .v-date-picker-table th {
  font-size: 15px;
  color: rgba(143, 155, 179, 1) !important; /*change days name color text*/
  height: 44px;
  border-bottom: 1px solid rgb(244,244,244);
  border-top: 1px solid rgb(244,244,244);
}

::v-deep .v-date-picker-table--date {
  height: 290px;
}

::v-deep .v-date-picker-table .v-btn {
  height: 44px;
  width: 44px;
  font-size: 15px !important;
  font-weight: 600;
  border-radius: 4px !important;
}
::v-deep .v-date-picker-table__current {
  border: 2px solid black; /*change current date color border*/
  color: black !important;
  background-color: rgba(51, 51, 51, 0.08); /*change current date color bg*/
}
::v-deep .v-date-picker-table .v-btn.v-btn--disabled {
  color:rgba(143, 155, 179, 1) !important; /*change disabled date color text*/
}

::v-deep .v-date-picker-table .v-btn.v-btn--active {
  background-color: rgba(102, 144, 255, 1); /*change active/selected date color bg*/
}

::v-deep .v-date-picker-table--date .v-date-picker-table__events {
  bottom: 12px;
}

::v-deep .v-date-picker-table__events > div {
  width: 5px;
  height: 5px;
}

::v-deep .v-date-picker-table--month td .v-btn {
  margin: 0 auto;
  max-width: 140px;
  min-width: 40px;
  width: 100%;
  font-size: 15px !important;
  font-weight: 600 !important;
}
::v-deep .v-date-picker-years {
  font-size: 15px;
  font-weight: 600;
  height: 290px;
  list-style-type: none;
  overflow: auto;
  text-align: center;
}

</style>